<template>
  <div>
    <router-view />
    <UpdateNotification />
    <EUCMChatBubble v-if="route.path !== '/'" />
    <Admin2FAGate ref="admin2FAGate" />
    <CookieBanner />
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import UpdateNotification from '@/components/version/UpdateNotification.vue'
import EUCMChatBubble from '@/components/EUCMChatBubble.vue'
import Admin2FAGate from '@/components/Admin2FAGate.vue'
import CookieBanner from '@/components/CookieBanner.vue'
import { useOrganizationStore } from '@/stores/organization'

const route = useRoute()
const orgStore = useOrganizationStore()
const admin2FAGate = ref<InstanceType<typeof Admin2FAGate>>()

onMounted(() => {
  orgStore.fetchOrganization()
  
  window.addEventListener('admin-2fa-required', () => {
    admin2FAGate.value?.openModal()
  })
})
</script>
